<div role="status" aria-live="polite">
  @if (banner) {
  <app-notification-banner-card class="home-banner" [title]="banner.title" [message]="banner.message"></app-notification-banner-card>
  }
</div>
<h1 id="welcome-message">Welcome to {{ dealer.name }} Bib Tread Next !</h1>
